module.exports = __webpack_public_path__ + "img/logo3.7f74cd3c.png";